import { ref } from "vue";

export default function useEventManager() {
  const listeners = ref({});

  // Event dinleme
  const on = (event, callback) => {
    if (!listeners.value[event]) {
      listeners.value[event] = [];
    }
    listeners.value[event].push(callback);

    return () => off(event, callback);
  };

  // Event dinlemeyi durdurma
  const off = (event, callback) => {
    if (!listeners.value[event]) return;
    listeners.value[event] = listeners.value[event].filter(
      (cb) => cb !== callback
    );
  };

  // Event tetikleme
  const emit = (event, ...args) => {
    if (!listeners.value[event]) return;
    listeners.value[event].forEach((callback) => callback(...args));
  };

  // Temizlik fonksiyonu
  const cleanup = () => {
    listeners.value = {};
  };

  // Not: onUnmounted hook'u setup context'i dışında (ör. main.js'de global property olarak)
  // çağrıldığında uyarı verir. Bu yüzden lifecycle hook'u kaldırdık.
  // Global property olarak kullanıldığında app unmount olduğunda zaten tüm kaynaklar temizlenir.
  // Component'ler içinde kullanıldığında ise, component unmount olduğunda ref'ler otomatik temizlenir.
  // Eğer manuel cleanup gerekiyorsa, cleanup() fonksiyonu kullanılabilir.

  return { on, off, emit, cleanup };
}
